import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';
const Periscope = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:7085';
  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
   
    // Dynamically extract all query parameters without altering case
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value; // Keep keys as they are
    });
 
    console.log('Extracted Query Parameters:', params); // Log the extracted parameters
   
    fetchPeriscopeURL(params);  
  }, [location]);
 
  const fetchPeriscopeURL = async (params) => {
    
    try {
      
      console.log('Request parameters:', params);
      const response = await axios.get(`${API_URL}/api/Periscope/GetPeriscopeLink`, {
        params: {
          ...params
        }
      });
 
      console.log('API Response:', response.data);
 
      setLoading(false);
 
 
      if (response.data && response.data.url) {
 
        window.location.href = response.data.url;
      }
      else if (response.data && response.data.redirectUrl) {
 
        window.location.href = response.data.redirectUrl;
      }
      else {
        setError('periscope');
      }
    } catch (error) {
      console.error('Error fetching Periscope URL:', error);
      setError('periscope');
      setLoading(false);
    }
  };
 
  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="periscope" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <div style={{width: '99%'}}>
                  <div style={{marginLeft: '49%'}}>
                    <div style={{float: 'left'}}>
                      <img src={LoadingImage} id="loadinggif" alt="Loading" />
                    </div>
                    <div id="loadingtext" style={{float: 'left'}}> Loading...</div>
                  </div>
                </div>
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center">
              <div style={{fontSize: 'larger'}}></div>
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
 
export default Periscope;